import { CartProduct } from 'cart-core';
import t from 'rcm-i18n';
import React, { useCallback } from 'react';
import './style.scss';
import { Category } from './types';

interface Props {
  category: Category;
  onOpen?: (product: CartProduct) => void;
}

const CategoryProducts = ({
  category: { products = {}, productIds = [] },
  onOpen = () => {},
}: Props) => (
  <div className='category-products'>
    {productIds
      .filter((id) => products[id])
      .map((id) => {
        const product: CartProduct = products[id];
        const { name, image, thumbImage, detailPageUrl } = product;
        const handleClick = useCallback(() => {
          onOpen(product);
        }, [onOpen]);
        return (
          <div className='product' key={id}>
            <div className='product-image'>
              <a href={detailPageUrl}>
                <img className='hidden-xs' src={image} />
                <img className='visible-xs' src={thumbImage} />
              </a>
            </div>
            <div className='product-label'>
              <a href={detailPageUrl}>{name}</a>
              <div>
                <button
                  className='open-add-to-cart-window btn btn-primary add-to-cart-button'
                  onClick={handleClick}
                >
                  {t('Add to Cart')}
                </button>
              </div>
            </div>
          </div>
        );
      })}
  </div>
);

export default CategoryProducts;
